import React from 'react';
import { Box, Preloader, Text, useAutoFontSize } from '@common-fe/common-fe';

import { useNumberFormat } from '@/utils';

import { EnrolledBlockPayload } from '../Dashboard.type';

import BannerItem from './BannerItem';
import EnrolledBlockPlans from './EnrolledBlockPlans';

interface Props {
  isLoading: boolean;
  data: EnrolledBlockPayload | null;
}
const EnrolledBlock: React.FC<Props> = ({ isLoading, data }) => {
  const { containerRef, fontSize } = useAutoFontSize(`${data?.enrolledCount || 0}`, {
    maxFontSize: 30,
  });
  const enrolledCountFormatted = useNumberFormat(`${data?.enrolledCount || 0}`);
  const unenrolledCountFormatted = useNumberFormat(`${data?.unenrolledCount || 0}`);
  return (
    <Box data-testid="dashboard_banner_enrolled-block" direction="column" style={{ flex: 1 }}>
      <BannerItem fill round={{ corner: 'top', size: 'moduleRound' }} margin={{ bottom: '1px' }}>
        <Box align="center" justify="center">
          {isLoading ? (
            <Preloader data-testid="dashboard_banner_enrolled-block_loader" size={32} />
          ) : (
            <>
              <BannerItem.Title
                data-testid="dashboard_banner_enrolled-block_enrolled-count"
                ref={containerRef}
                size={`${fontSize}px`}
                weight={700}
              >
                {enrolledCountFormatted}
              </BannerItem.Title>
              <Box direction="row">
                <Text
                  data-testid="dashboard_banner_enrolled-block_enrolled-label"
                  color="textOnColor"
                  style={{
                    opacity: 0.5,
                  }}
                >
                  Enrolled
                </Text>

                <EnrolledBlockPlans items={data?.planCategories} />
              </Box>
            </>
          )}
        </Box>
      </BannerItem>

      <BannerItem fill round={{ corner: 'bottom', size: 'moduleRound' }} margin={{ top: '1px' }}>
        <Box align="center" justify="center">
          {isLoading ? (
            <Preloader data-testid="dashboard_banner_enrolled-block_loader" size={32} />
          ) : (
            <>
              <BannerItem.Title
                data-testid="dashboard_banner_enrolled-block_unenrolled-count"
                size="30px"
                weight={700}
              >
                {unenrolledCountFormatted}
              </BannerItem.Title>

              <Text
                data-testid="dashboard_banner_enrolled-block_unenrolled-label"
                color="textOnColor"
                style={{
                  opacity: 0.5,
                }}
              >
                Unenrolled
              </Text>
            </>
          )}
        </Box>
      </BannerItem>
    </Box>
  );
};

export default EnrolledBlock;
